import React, { Component } from 'react';
import 'font-awesome/css/font-awesome.min.css';
export default class Header extends Component {
    render() {
        return(
            <React.Fragment>
            <header id="home">
                <nav id="nav-wrap">
                    <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
                    <a className="mobile-btn" href="#" title="Hide navigation">Hide navigation</a>
                    <ul id="nav" className="nav">
                    <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
                    <li><a className="smoothscroll" href="#about">About</a></li>
                    <li><a className="smoothscroll" href="#portfolio">Portfolio</a></li>
                    </ul> {/* end #nav */}
                </nav> {/* end #nav-wrap */}
                <div className="row banner">
                    <div className="banner-text">
                    <h1 className="responsive-headline">I'm Alija Rasyidi Daud.</h1>
                    <h3>I'm a <span>game programmer</span>, and <span>game developer</span> that love to create awesome
                        world and experience through game to spark joy for everyone. 
                        You can learn more <a className="smoothscroll" href="#about">about me </a>,
                        and don't hesitate to say hi.</h3>
                    <hr />
                    <ul className="social">
                        <li><a href="https://github.com/alijarasyidi"><i className="fa fa-github" /></a></li>
                        <li><a href="https://gitlab.com/alijarasyidi"><i className="fa fa-gitlab" /></a></li>
                        <li><a href="https://www.linkedin.com/in/alija-rasyidi-daud-7a19a614b"><i className="fa fa-linkedin" /></a></li>
                        <li><a href="https://api.whatsapp.com/send?phone=+6287887884824"><i className="fa fa-whatsapp" /></a></li>
                    </ul>
                    </div>
                </div>
                <p className="scrolldown">
                    <a className="smoothscroll" href="#about"><i className="icon-down-circle" /></a>
                </p>
            </header>
            </React.Fragment>
        )
    }
}